module.exports = __webpack_public_path__ + "img/8.91195539.jpg";